const translations: any = {
    'companies': 'nha-tuyen-dung',
    'company-list': 'danh-sach-cong-ty'
}

export default translations